import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { PersonAvatar } from '@/shared/components/PersonAvatar';
import { formatDateTime } from '@/shared/lib/format';
import type { Feedback } from '../api/feedbackApi';
import { plainAnswer } from '../model/plainAnswer';

/** Who rated the answer, where and when. */
export function Rater({ f }: { f: Feedback }) {
  return (
    <Stack direction="row" sx={{ alignItems: 'center', gap: 0.75, minWidth: 0 }}>
      <PersonAvatar name={f.userName} size={18} />
      <Typography variant="caption" noWrap sx={{ color: 'text.secondary' }}>
        {f.userName} · {f.channel === 'teams' ? 'Teams' : 'Portal'} · {formatDateTime(f.createdAt)}
      </Typography>
    </Stack>
  );
}

/** The answer as given, its first sentence in bold: the claim the RM rated. */
export function AnswerQuote({ text }: { text: string }) {
  const plain = plainAnswer(text);
  const lead = /^.*?[.!?](?=\s|$)/s.exec(plain)?.[0] ?? plain;
  return (
    <Typography variant="body2" sx={{ px: 2, py: 1.5, borderRadius: 1.25, bgcolor: 'surface.subtle', lineHeight: 1.6, whiteSpace: 'pre-line' }}>
      <strong>{lead}</strong>{plain.slice(lead.length)}
    </Typography>
  );
}
